// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_jl-0";